import React from "react";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";
// import { IoDocumentTextOutline } from "react-icons/io5";
// import { TbReportSearch } from "react-icons/tb";
import "../../borrowSystem/Report/ListReports.css"

export function ListReportSupportComponent() {
    return (
        <Container>
            <div className="d-flex flex-wrap justify-content-center align-items-center box-reports-support-container">

                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports-support">
                    <Link
                        to="/supporting/reports/report55"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >
                        {/* <TbReportSearch className="icon-doc"/> */}
                        <p className="px-3">การอนุมัติให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน</p>
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports-support">
                    <Link
                        to="/supporting/reports/report56"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >

                        <p className="px-3">หน่วยงานที่อนุมัติให้เงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน</p>
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports-support">
                    <Link
                        to="/supporting/reports/report57"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >

                        <p className="px-3">สรุปการใช้จ่ายเงินกองทุนพัฒนาฝีมือแรงงานเพื่อช่วยเหลือหรืออุดหนุน</p>
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports-support">
                    <Link
                        to="/supporting/reports/report58"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >

                        <p className="px-3">สรุปรวมการอนุมัติให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน</p>
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports-support">
                    <Link
                        to="/supporting/reports/report59"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >

                        <p className="px-3">แบบรายงานผลการพิจารณาอนุมัติการให้เงินช่วยเหลือหรืออุดหนุน<br />แก่ศูนย์ประเมินความรู้ความสามารถกลาง</p>
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports-support">
                    <Link
                        to="/supporting/reports/report60"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >

                        <p className="px-3">สรุปการอนุมัติให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน</p>
                    </Link>
                </div>

                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports-support">
                    <Link
                        to="/supporting/reports/report61"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >

                        <p className="px-3">รายงานการให้เงินช่วยเหลืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน</p>
                    </Link>
                </div>

                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports-support">
                    <Link
                        to="/supporting/reports/report62"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >

                        <p className="px-3">สรุปรายงานผลการดำเนินงานกรมพัฒนาฝีมือแรงงานของผู้ได้รับเงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน</p>
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports-support">
                    <Link
                        to="/supporting/reports/report63"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >

                        <p className="px-3">ข้อมูลทะเบียนรายงานเงินช่วยเหลือหรืออุดหนุน</p>
                    </Link>
                </div>
                {/* <iframe
                    title="Test_Power_BI_Pro"
                    width="1200"
                    height="700"
                    src="https://app.powerbi.com/view?r=eyJrIjoiODUwMzI2ZmQtOTllZi00ZDIyLTljMmUtY2FkMzE4ZTAwZDMwIiwidCI6ImVkMTlmMzNjLWI1OTItNDBlZS1iMDdjLTVlYWRlMGY1YzY2NiIsImMiOjEwfQ%3D%3D
                        &chromeless=1
                        &navContentPaneEnabled=false
                        &filterPaneEnabled=false"
                    frameborder="0"
                    allowFullScreen>
                </iframe> */}

                {/* <iframe
                    title="Test_Power_BI_Pro"
                    width="1200"
                    height="700"
                    src="https://app.powerbi.com/reportEmbed?reportId=256857d3-e48b-42c1-ac9e-65b6b4ee8a50&autoAuth=true&ctid=ed19f33c-b592-40ee-b07c-5eade0f5c666
                        &chromeless=1
                        &navContentPaneEnabled=false
                        &filterPaneEnabled=false"
                    frameborder="0"
                    allowFullScreen>
                </iframe> */}
            </div>
            <div class="boxes-tn">
                <div></div> <div></div>
                <div></div> <div></div>
                <div></div> <div></div>
                <div></div> <div></div>
                <div></div>
            </div>
        </Container>
    )
}